module.exports = __webpack_public_path__ + "img/shipping_providers.a8734600.svg";